export var ProjectConfigurationKeyEnum;
(function (ProjectConfigurationKeyEnum) {
    ProjectConfigurationKeyEnum["ENVIRONMENT_CLASSIFICATION_PATTERNS"] = "ENVIRONMENT_CLASSIFICATION_PATTERNS";
})(ProjectConfigurationKeyEnum || (ProjectConfigurationKeyEnum = {}));
